import { theme } from 'lib/style';
import React from 'react';
import styled from 'styled-components/macro';
import { Button } from 'react-covideo-common';
import { MdDeleteForever } from 'react-icons/md';
import { Flex } from 'lib/components/styles/layout';

const NameContainer = styled.div`
  height: 40px;
  border-radius: 6px;
  border: 1px solid ${theme.palette.covideoBlue20};
  padding: 8px 12px;
  box-sizing: border-box;
  width: 372px;
`;

type RegionProps = {
  name: string;
  onRemove: () => void;
};

const RegionCard = ({ name, onRemove }: RegionProps) => {
  return (
    <Flex flexDirection='row' gap='8px'>
      <NameContainer>{name}</NameContainer>
      <Button
        onClick={onRemove}
        icon={<MdDeleteForever size={20} color={theme.palette.red100} />}
        text='Remove'
        variant='destructive'
      />
    </Flex>
  );
};

export default RegionCard;
